import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "arrow-left-right",
  "use": "arrow-left-right-usage",
  "viewBox": "0 0 65 65",
  "content": "<symbol viewBox=\"0 0 65 65\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"arrow-left-right\">\r\n<path d=\"M42.5 31.5L15 31.5M15 31.5L20.5 37M15 31.5L20.5 26\" stroke=\"black\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" />\r\n<path d=\"M28.5 31.5H50M50 31.5L44.5 26M50 31.5L44.5 37\" stroke=\"black\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol